// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P48C","tabsBox":"styles_tabsBox__1XGyq","createButton":"styles_createButton__3Vgua"};